<template>
    <i style="display: inline-flex">
        <svg :width="11" :height="6" viewBox="0 0 11 6" fill="none">
            <path
                :fill="fill"
                d="M5.5 6C5.21552 6 5.02591 5.91178 4.83625 5.7353L0.284483 1.50002C-0.0948276 1.14708 -0.0948276 0.617647 0.284483 0.264706C0.663793 -0.0882353 1.23278 -0.0882353 1.61209 0.264706L5.5 3.88239L9.38791 0.264706C9.76722 -0.0882353 10.3362 -0.0882353 10.7155 0.264706C11.0948 0.617647 11.0948 1.14708 10.7155 1.50002L6.16375 5.7353C5.97409 5.91178 5.68965 6 5.5 6Z"
            />
        </svg>
    </i>
</template>

<script>
export default {
    props: {
        fill: {
            type: String,
            default: ""
        }
    },
    name: "ArrowDownSmallIcon"
}
</script>

<style scoped lang="sass">

</style>
